import {
  getKanbanWidgetAssembleInfo,
  // getProjectKanbanConfig,
  getDefaultKanbanConfig
} from 'common-module/src/components/Kanban/api/kanban';
// import { tryToNumber } from '@zk/framework-vue';
export async function getKanbanConfig(projectList, _projectId, defaultConfigs){
  let config = {};
  if (_projectId) {
    // config = await getProjectKanbanConfig(_projectId);
    config = await getKanbanWidgetAssembleInfo({
      projectId: _projectId
    });
  } else {
    config = defaultConfigs ? defaultConfigs : await getDefaultKanbanConfig();
  }

  const projectId = config.sprintTrackFilterVO?.projectId;
  const projectName = projectList.find(i => i.id === projectId)?.pname;
  const habitKey = `userHabit-${projectId}`;
  const filterKey = `filter-${projectId}`;
  const operateSortMapKey = `operateSortMap-${projectId}`;
  // const filterValueKey = `filterValue-${projectId}`;
  console.log('--getKanbanConfig--', config);
  let workFlowId = config.issueTypeWorkflowGroupVOList?.find(i => {
    return i.issueTypes.some(issueType => {
      return config.sprintTrackFilterVO?.issueTypeIds.includes(issueType.id);
    });
  })?.id;
  if (!workFlowId && config.issueTypeWorkflowGroupVOList) {
    workFlowId = config.issueTypeWorkflowGroupVOList[0]?.id;
  }
  const queryFilter = config.sprintTrackFilterVO?.queryFilter;
  const settings = {
    projectId,
    projectName,
    [habitKey]: {
      planSprintSelect: queryFilter?.filterFields?.and?.sprint?.columnFilter?.[0]?.values || [],
      kanbanIssueType: config.sprintTrackFilterVO?.issueTypeIds,
      workFlowId: workFlowId,
      subTaskFilterTurnOff: false
    }
  };
  Object.keys(config.customerHabitMap || {}).forEach((key) => {
    settings[habitKey][key] = config.customerHabitMap[key].linkIdList;
  });
  settings[filterKey] = queryFilter?.filterFields?.and;
  settings[operateSortMapKey] = queryFilter?.operateSortMap;
  // if (config.addedFilterFieldList) {
  //   // settings[filterKey] = config.addedFilterFieldList.map(i => {
  //   //   return {
  //   //     id: i.customFieldId,
  //   //     code: i.customFieldCode,
  //   //     controlCode: i.controlCode,
  //   //     customFieldName: i.customFieldName
  //   //   };
  //   // });
  // }
  // if (config.selectOptionMap) {
  //   settings[filterValueKey] = Object.keys(config.selectOptionMap).map(key => {
  //     return {
  //       id: key,
  //       value: config.selectOptionMap[key].map(i => tryToNumber(i)).map(v => v === 'null' ? null : v)
  //     };
  //   });
  // }

  return settings;
}